// Vendor Libraries
import { ElementRef } from '@angular/core';
// Constants
import { CORE_COLOR_MAP } from 'NewAngular/constants/core.constants';
// Interfaces / types / enums
import { ScatterPlotDataShape, ScatterPlotDataShapeSize, ScatterPlotStatus, } from 'ChartApp/ts/enums/scatter-plot-common.enum';
// Services
import { SecuritiesService } from 'SecuritiesApp/ts/services/securities.service';
import { ScatterPlotService } from 'ChartApp/ts/services/scatter-plot.service';
import { ChartZoomService } from 'ChartApp/ts/features/charts-shared/services/chart-zoom.service';
// Directives
import { ScatterPlotBaseDirective } from 'ChartApp/ts/features/scatter-plot/directives/scatter-plot-base.directive';
// Utilities
import { YChartsSentryUtils } from 'NewAngular/services/sentry/sentry-utils';
import * as i0 from "@angular/core";
import * as i1 from "ChartApp/ts/services/scatter-plot.service";
import * as i2 from "SecuritiesApp/ts/services/securities.service";
import * as i3 from "@angular/common";
import * as i4 from "../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i5 from "../../../../../../charts/static/charts/ts/features/scatter-plot/components/scatter-plot/scatter-plot.component";
const _c0 = a0 => ({ "color": a0 });
const _c1 = () => ({ height: "100%" });
function RiskInfoScatterPlotComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6)(1, "span", 7)(2, "span", 8);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(3, "svg", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelement(4, "a", 10);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const legendItem_r1 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", "size-sm")("ngStyle", i0.ɵɵpureFunction1(5, _c0, legendItem_r1.color));
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-shape-" + legendItem_r1.shape);
    i0.ɵɵadvance();
    i0.ɵɵproperty("href", legendItem_r1.url, i0.ɵɵsanitizeUrl)("textContent", legendItem_r1.id);
} }
function RiskInfoScatterPlotComponent_ycn_scatter_plot_4_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ycn-scatter-plot", 11);
    i0.ɵɵlistener("customClick", function RiskInfoScatterPlotComponent_ycn_scatter_plot_4_Template_ycn_scatter_plot_customClick_0_listener() { i0.ɵɵrestoreView(_r2); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.redirectToScatterPlotWindow()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("errorMessage", ctx_r2.error.message)("scatterPlotInfo", ctx_r2.scatterPlotInfo)("status", ctx_r2.status)("ychartsScatterPlotService", ctx_r2.ychartsScatterPlotService)("hideZoomInstructions", true);
} }
function RiskInfoScatterPlotComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12)(1, "div", 13);
    i0.ɵɵtext(2, "No Data Available");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    i0.ɵɵstyleMap(i0.ɵɵpureFunction0(2, _c1));
} }
function RiskInfoScatterPlotComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12)(1, "div", 14)(2, "a", 15);
    i0.ɵɵtext(3, "Upgrade now.");
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵstyleMap(i0.ɵɵpureFunction0(3, _c1));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("href", ctx_r2.featurePaymentUrl, i0.ɵɵsanitizeUrl);
} }
export class RiskInfoScatterPlotComponent extends ScatterPlotBaseDirective {
    constructor(eltRef, scatterPlotService, securitiesService) {
        super();
        this.eltRef = eltRef;
        this.scatterPlotService = scatterPlotService;
        this.securitiesService = securitiesService;
        this.comparables = [];
        this.USER = window.USER;
        this.showBenchmark = this.eltRef.nativeElement.getAttribute('riskShowBenchmark');
        this.showComparables = this.eltRef.nativeElement.getAttribute('riskShowComparables');
        this.showHoldings = this.eltRef.nativeElement.getAttribute('riskShowHoldings');
        this.scatterPlotTabUrl = this.eltRef.nativeElement.getAttribute('scatterPlotTabUrl');
        this.isModelPortfolio = this.eltRef.nativeElement.getAttribute('isModelPortfolio');
        this.disableComparison = this.eltRef.nativeElement.getAttribute('disableComparison');
        this.securityId = this.eltRef.nativeElement.getAttribute('securityId');
        this.benchmarkSecurityId = this.eltRef.nativeElement.getAttribute('benchmarkSecurityId');
        this.featurePaymentUrl = this.eltRef.nativeElement.getAttribute('featurePaymentUrl');
        this.benchmarkUrl = this.eltRef.nativeElement.getAttribute('benchmarkUrl');
        this.securityHoldingsUrl = this.eltRef.nativeElement.getAttribute('securityHoldingsUrl');
        this.securityUrl = this.eltRef.nativeElement.getAttribute('securityUrl');
        const scatterPlotCalcNames = JSON.parse(this.eltRef.nativeElement.getAttribute('scatterPlotCalcNames'));
        this.benchmarkDisabled = this.eltRef.nativeElement.getAttribute('benchmarkDisabled');
        [this.xAxisMetric, this.yAxisMetric] = scatterPlotCalcNames;
    }
    async ngOnInit() {
        if (this.USER.authenticated) {
            await this.setScatterPlotDataParams();
        }
    }
    ngOnDestroy() {
        super.ngOnDestroy();
    }
    async setScatterPlotDataParams() {
        this.status = ScatterPlotStatus.loading;
        let securities = `id:${this.securityId},include:true,type:security,,`;
        if (this.showBenchmark && !this.disableComparison) {
            securities += `id:${this.benchmarkSecurityId},include:true,type:security,,`;
        }
        if (this.showComparables && !this.disableComparison) {
            this.comparables = (await this.securitiesService
                .getUserRelatedSecurities(this.securityId)
                .toPromise());
            this.comparables.forEach((comparable) => {
                securities += `id:${comparable.securityId},include:true,type:security,,`;
            });
        }
        if (this.showHoldings && this.isModelPortfolio) {
            securities += `id:model-portfolio-${this.securityId.substring(2)}
            ,include:true,security_group:multi,type:security_list,,`;
        }
        this.scatterPlotDataParams = {
            securities,
            xAxisMetric: this.xAxisMetric,
            yAxisMetric: this.yAxisMetric,
            displayLegend: false,
        };
        this.setLegend();
        if (this.fetchSubscription !== null) {
            this.fetchSubscription.unsubscribe();
        }
        this.fetchSubscription = this.handleFetch();
    }
    setLegend() {
        this.legend = [
            {
                color: CORE_COLOR_MAP[1].code,
                shape: ScatterPlotDataShape.circle,
                id: this.securityId,
                size: ScatterPlotDataShapeSize.medium,
                url: this.securityUrl,
            },
        ];
        if (this.showBenchmark && !this.disableComparison && !this.benchmarkDisabled) {
            this.legend.push({
                color: CORE_COLOR_MAP[2].code,
                shape: ScatterPlotDataShape.triangle,
                id: 'BENCHMARK',
                size: ScatterPlotDataShapeSize.medium,
                url: this.benchmarkUrl,
            });
        }
        if (this.showHoldings && this.isModelPortfolio) {
            this.legend.push({
                color: CORE_COLOR_MAP[3].code,
                shape: ScatterPlotDataShape.circle,
                id: `HOLDINGS`,
                size: ScatterPlotDataShapeSize.small,
                url: this.securityHoldingsUrl,
            });
        }
        if (this.showComparables && !this.disableComparison) {
            this.comparables.forEach((comparable, index) => {
                const colorIndex = (index % 9) + 4;
                this.legend.push({
                    color: CORE_COLOR_MAP[colorIndex].code,
                    shape: ScatterPlotDataShape.circle,
                    id: comparable.securityId,
                    size: ScatterPlotDataShapeSize.medium,
                    url: comparable.url,
                });
            });
        }
    }
    setSeries() {
        this.scatterPlotInfo.data.series.forEach((series) => {
            let item = this.legend.find((_) => _.id === series.id);
            if (!item && series.type === 'security_list') {
                item = this.legend.find((_) => _.id.includes('HOLDINGS'));
                item.id = `HOLDINGS: ${series.data.length} ITEM${series.data.length === 1 ? '' : 'S'}`;
            }
            if (!item) {
                item = this.legend.find((_) => _.id.includes('BENCHMARK'));
            }
            if (item) {
                // eslint-disable-next-line no-param-reassign
                series.color = item.color;
                // eslint-disable-next-line no-param-reassign
                series.shape = item.shape;
                // eslint-disable-next-line no-param-reassign
                series.size = item.size;
            }
        });
    }
    handleFetch() {
        const scatterPlotDataObservable = this.scatterPlotService.getScatterPlotData(this.scatterPlotDataParams);
        // Only make a request if data can be returned for the get params
        if (scatterPlotDataObservable) {
            this.status = ScatterPlotStatus.loading;
            return scatterPlotDataObservable.subscribe({
                next: (rsp) => {
                    this.scatterPlotInfo = { ...rsp };
                    this.setSeries();
                    // Filter data for series within the data limit
                    const seriesWithinDataLimit = this.ychartsScatterPlotService.filterSeriesWithTooManyPoints(this.scatterPlotInfo.data.series);
                    this.scatterPlotInfo.data.series = seriesWithinDataLimit;
                    if (seriesWithinDataLimit.length === 0) {
                        this.status = ScatterPlotStatus.allSeriesExceedDataLimit;
                    }
                    else if (!this.ychartsScatterPlotService.seriesDataExists(rsp.data.series)) {
                        this.status = ScatterPlotStatus.noData;
                    }
                    else {
                        this.status = ScatterPlotStatus.ok;
                    }
                },
                error: (error) => {
                    this.status = ScatterPlotStatus.error;
                    this.error = error.error;
                    // Only capture unexpected exceptions
                    if (!this.backendErrorCodes.has(this.error.code)) {
                        YChartsSentryUtils.captureException(error);
                    }
                },
            });
        }
        this.status = ScatterPlotStatus.noData;
        return null;
    }
    redirectToScatterPlotWindow() {
        let url = `${this.scatterPlotTabUrl}#/?securities=${this.scatterPlotDataParams.securities}&xAxisMetric=${this.scatterPlotDataParams.xAxisMetric}&yAxisMetric=${this.scatterPlotDataParams.yAxisMetric}&plotOptions=`;
        const lastIndex = this.scatterPlotInfo.data.series.length - 1;
        this.scatterPlotInfo.data.series.forEach((series, index) => {
            url += `security__${series.id}:::size::${series.size},,color::%23${series.color.substring(1)},,shape::${series.shape}${index === lastIndex ? '' : ',,,'}`;
        });
        window.location.href = url;
    }
}
RiskInfoScatterPlotComponent.ɵfac = function RiskInfoScatterPlotComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || RiskInfoScatterPlotComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.ScatterPlotService), i0.ɵɵdirectiveInject(i2.SecuritiesService)); };
RiskInfoScatterPlotComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: RiskInfoScatterPlotComponent, selectors: [["ycn-risk-info-scatter-plot"]], standalone: false, features: [i0.ɵɵProvidersFeature([ChartZoomService]), i0.ɵɵInheritDefinitionFeature], decls: 7, vars: 4, consts: [[1, "chart-options"], [1, "chart-legend"], ["class", "chart-legend-item", 4, "ngFor", "ngForOf"], [1, "chart-canvas", "full-height"], ["class", "chart-canvas d-flex flex-column", 3, "errorMessage", "scatterPlotInfo", "status", "ychartsScatterPlotService", "hideZoomInstructions", "customClick", 4, "ngIf"], ["class", "get-started", 3, "style", 4, "ngIf"], [1, "chart-legend-item"], [1, "chart-legend-item-title", "custom-bullet"], [1, "shape-select-choice", "text-21", 3, "ngClass", "ngStyle"], ["ycnIcon", "", 3, "name"], ["href", "javascript:void(0)", 1, "chart-legend-item-title", "text-21", 3, "href", "textContent"], [1, "chart-canvas", "d-flex", "flex-column", 3, "customClick", "errorMessage", "scatterPlotInfo", "status", "ychartsScatterPlotService", "hideZoomInstructions"], [1, "get-started"], [1, "panel-data-empty-message"], [1, "panel-data-empty-message", "panel-ad-cta"], [3, "href"]], template: function RiskInfoScatterPlotComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        i0.ɵɵtemplate(2, RiskInfoScatterPlotComponent_div_2_Template, 5, 7, "div", 2);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵtemplate(4, RiskInfoScatterPlotComponent_ycn_scatter_plot_4_Template, 1, 5, "ycn-scatter-plot", 4)(5, RiskInfoScatterPlotComponent_div_5_Template, 3, 3, "div", 5)(6, RiskInfoScatterPlotComponent_div_6_Template, 4, 4, "div", 5);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngForOf", ctx.legend);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.status != "noData" && ctx.USER.authenticated);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.status == "noData");
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.USER.authenticated);
    } }, dependencies: [i3.NgClass, i3.NgForOf, i3.NgIf, i3.NgStyle, i4.IconDirective, i5.ScatterPlotComponent], encapsulation: 2 });
